var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewZealand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1037_17725)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1037_17725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V12H24V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3L14.2747 3.70805L15 3.76393L14.4444 4.25741L14.618 5L14 4.59694L13.382 5L13.5556 4.25741L13 3.76393L13.7253 3.70805L14 3Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1L17.2747 1.70805L18 1.76393L17.4444 2.25741L17.618 3L17 2.59694L16.382 3L16.5556 2.25741L16 1.76393L16.7253 1.70805L17 1Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9L17.2747 9.70805L18 9.76393L17.4444 10.2574L17.618 11L17 10.5969L16.382 11L16.5556 10.2574L16 9.76393L16.7253 9.70805L17 9Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 6L0 0ZM0 6L12 0L0 6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6L12 0M0 0L12 6L0 0Z",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 6L0 0ZM0 6L12 0L0 6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6L12 0M0 0L12 6L0 0Z",
    stroke: "#C8102E",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0V6V0ZM0 3H12H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3H12M6 0V6V0Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0V6V0ZM0 3H12H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3H12M6 0V6V0Z",
    stroke: "#C8102E",
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1037_17725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1037_17725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/new-zealand.8f0b4f0df833e67e67c024231b5486c6.svg";
export { ForwardRef as ReactComponent };